import React from 'react';
import { CircularProgress } from '@/components/ui/circular-progress';

interface NutritionMetricStatusCardProps {
  label: string;
  value: number;
  percentage: number;
  color: string;
  /** Omit card border (e.g. nested inside another bordered section). */
  hideBorder?: boolean;
}

const NutritionMetricStatusCard: React.FC<NutritionMetricStatusCardProps> = ({
  label,
  value,
  percentage,
  color,
  hideBorder = false,
}) => {
  const pct = Math.min(Number(percentage.toFixed(2)), 100);
  const noWrapTextStyle: React.CSSProperties = {
    overflowWrap: 'normal',
    wordBreak: 'normal',
  };

  return (
    <div
      className={
        hideBorder
          ? 'flex items-center gap-3 rounded-[16px] p-4 xl:gap-5 xl:p-5'
          : 'flex items-center gap-3 rounded-[16px] border border-[#0000001A] p-4 xl:gap-5 xl:p-5'
      }
      style={{ overflowWrap: 'normal' }}
    >
      <CircularProgress percentage={pct} color={color} size={54} strokeWidth={5} />
      <div className="min-w-0">
        <p
          className="mb-1 whitespace-nowrap text-[13px] font-bold text-slate-900"
          style={noWrapTextStyle}
        >
          {label}
        </p>
        <div className="mb-1 flex items-center gap-2">
          <span className="whitespace-nowrap text-[12px] text-slate-400" style={noWrapTextStyle}>
            {value}g
          </span>
          <span className="whitespace-nowrap text-[12px] font-bold text-slate-700" style={noWrapTextStyle}>
            {pct}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default NutritionMetricStatusCard;
